"use strict";
import React from "react";
import { OptionMenuClassName } from "./OptionMenu";
const OptionMenuSeparator = () => {
  return /* @__PURE__ */ React.createElement("hr", { className: `${OptionMenuClassName}__separator` });
};
export default OptionMenuSeparator;
